"use client"
import React, { useEffect } from "react"
import { redirect } from "next/navigation"
import { useReadLocalStorage } from "usehooks-ts"
import { NoSsr } from "@mui/material"
type ComponentType = React.ComponentType<any>

const ProtectedAuth = (Component: ComponentType) => {
  const Auth = (props: any) => {
    const validUser = useReadLocalStorage("accessToken")

    useEffect(() => {
      if (validUser === null) {
        redirect("/login")
      }
    }, [validUser])

    return (
      <>
        {validUser ? (
          <NoSsr>
            <Component {...props} />
          </NoSsr>
        ) : null}
      </>
    )
  }
  return Auth
}
export default ProtectedAuth
